<template>
  <div class="container">
    <div class="map" style="height: 400px;">
      <l-map
        :zoom="zoom"
        maxZoom="13"
        :center="center"
        @update:zoom="zoomUpdated"
        @update:center="centerUpdated"
        @update:bounds="boundsUpdated"
      >
        <l-tile-layer :url="url"></l-tile-layer>
        <l-marker :lat-lng="[29.705, -95.405]" :icon="icon"> </l-marker>
        <l-circle :lat-lng="[29.705, -95.405]" radius="4500" color="red" />
        <l-marker :lat-lng="center">
          <l-icon
            style="border-radius: 50%;"
            :icon-size="dynamicSize"
            :icon-anchor="dynamicAnchor"
            icon-url="https://www.thenational.ae/image/policy:1.772123:1546257123/lf-new-restaurants-1.jpg?f=16x9&w=1200&$p$f$w=c007774"
          >
          </l-icon>
        </l-marker>
        <!-- todo: https://github.com/Leaflet/Leaflet.markercluster -->
        <l-marker :lat-lng="[29.705, -95.405]">
          <l-icon :icon-anchor="[16, 17]" class-name="someExtraClass">
            <div class="headline">{{ restaurantName }}</div>
            <b-img
              rounded="circle"
              class="popular"
              style="width:40px;height:40px"
              src="https://www.thenational.ae/image/policy:1.772126:1537425519/lf-lantern-moon-fest.jpg?f=default&q=1.0&w=1024&$p$f$q$w=633f11a"
            ></b-img>
          </l-icon>
          <l-popup>Hello!</l-popup>
        </l-marker>
      </l-map>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LIcon, LPopup } from "vue2-leaflet";
import L from "leaflet";

export default {
  name: "leaflet_map",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup
  },
  data() {
    return {
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 3,
      center: [29.705, -95.405],
      bounds: null,
      restaurantName: "China Star",
      icon: L.icon({
        iconUrl:
          "https://www.thenational.ae/image/policy:1.772124:1537425506/lf-eve.jpg?f=default&q=1.0&w=1024&$p$f$q$w=0c56541",
        iconSize: [32, 37],
        iconAnchor: [16, 37]
      })
    };
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    }
  },
  methods: {
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    }
  }
};
</script>

<style>
img.popular {
  /* box-shadow: 0px 0px 15px #f00; */
  -webkit-animation: glowing 2500ms infinite;
  -moz-animation: glowing 2500ms infinite;
  -o-animation: glowing 2500ms infinite;
  animation: glowing 2500ms infinite;
}

/* glowing effect */
@-webkit-keyframes glowing {
  0% {
    background-color: #b20000;
    -webkit-box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #ff0000;
    -webkit-box-shadow: 0 0 20px #ff0000;
  }
  100% {
    background-color: #b20000;
    -webkit-box-shadow: 0 0 3px #b20000;
  }
}

@-moz-keyframes glowing {
  0% {
    background-color: #b20000;
    -moz-box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #ff0000;
    -moz-box-shadow: 0 0 20px #ff0000;
  }
  100% {
    background-color: #b20000;
    -moz-box-shadow: 0 0 3px #b20000;
  }
}

@-o-keyframes glowing {
  0% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #ff0000;
    box-shadow: 0 0 20px #ff0000;
  }
  100% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
}

@keyframes glowing {
  0% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #ff0000;
    box-shadow: 0 0 20px #ff0000;
  }
  100% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
}
</style>
